import { LocalTui } from "../tui/renderer.js";

import type { Component, FleetPtyApi } from "./types.js";

export type RenderCallback = () => void;
export type RenderScheduler = (afterRender?: RenderCallback) => void;

interface RenderSchedulerUi {
  requestRender(force?: boolean, afterRender?: RenderCallback): void;
}

const RENDER_THROTTLE_MS = 16;

export function createRenderScheduler(ui: RenderSchedulerUi, beforeRender: () => void): RenderScheduler {
  let renderPending = false;
  let afterRenderCallbacks: RenderCallback[] = [];
  return (afterRender?: RenderCallback) => {
    if (afterRender !== undefined) {
      afterRenderCallbacks.push(afterRender);
    }

    if (renderPending) {
      return;
    }

    renderPending = true;
    setTimeout(() => {
      renderPending = false;
      const callbacks = afterRenderCallbacks;
      afterRenderCallbacks = [];
      beforeRender();
      ui.requestRender(false, () => {
        for (const callback of callbacks) {
          callback();
        }
      });
    }, RENDER_THROTTLE_MS);
  };
}

export function createFleetPtyViewport(fleetPty: FleetPtyApi): Component {
  return {
    handleInput(data: string): void {
      fleetPty.dispatchInput(data);
    },
    invalidate(): void {
      fleetPty.getCurrentRegion().component.invalidate();
    },
    render(width: number): string[] {
      return fleetPty.getCurrentRegion().component.render(width);
    },
  };
}

export function createCursorPolicySync(options: {
  readonly cursorSync: boolean;
  readonly fleetPty: FleetPtyApi;
  readonly hasActiveMissionControlPanel: () => boolean;
  readonly ptyView: Component;
  readonly ui: LocalTui;
}): () => void {
  return () => {
    if (
      !options.cursorSync
      || options.hasActiveMissionControlPanel()
      || options.fleetPty.hasActiveOverlay()
    ) {
      options.ui.setCursorAnchorTarget(undefined);
      return;
    }

    options.ui.setCursorAnchorTarget(options.ptyView);
  };
}
